module.exports = __webpack_public_path__ + "static/media/22.11c31507.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/22.jpg
// module id = 555
// module chunks = 0